import request from '@/utils/request'

const api = {
  Query(data) {
    return request({
      url: 'admin/user_group/query',
      method: 'post',
      data
    })
  },
  Delete(data) {
    return request({
      url: 'admin/user_group/delete',
      method: 'post',
      data
    })
  },
  IsExist(data) {
    return request({
      url: '/admin/user_group/isExist',
      method: 'post',
      data
    })
  },
  Update(data) {
    return request({
      url: 'admin/user_group/createOrUpdate',
      method: 'post',
      data
    })
  },
  Create(data) {
    return request({
      url: 'admin/user_group/createOrUpdate',
      method: 'post',
      data
    })
  },
  Detail(id) {
    return request({
      url: 'admin/user_group/detail',
      method: 'post',
      params: { id }
    })
  },
  Check(data) {
    return request({
      url: 'admin/user_group/check',
      method: 'post',
      data
    })
  },
  IsChecked(data) {
    return request({
      url: 'admin/user_group/isChecked',
      method: 'post',
      data
    })
  },
  Import(data) {
    return request({
      url: 'admin/user_group/import',
      method: 'post',
      data
    })
  },
  ChangePassword(data) {
    return request({
      url: 'admin/user_group/changePassword',
      method: 'post',
      data
    })
  },
  SaveSimple(data) {
    return request({
      url: 'admin/user_group/save_simple',
      method: 'post',
      data
    })
  },
  Login(data) {
    return request({
      url: '/admin/user_group/login',
      method: 'post',
      data
    })
  },

  Logout() {
    return request({
      url: 'admin/user_group/logout',
      method: 'post'
    })
  },
  UpdateInfo(data) {
    return request({
      url: 'admin/user_group/updateInfo',
      method: 'post',
      data
    })
  },
  GetAuthList() {
    return request({
      url: 'admin/user_group/getAuthList',
      method: 'post'
    })
  }
}

export default api
